import DataGrid from './mui-x/DataGrid';

export default theme => ({
	MuiDataGrid: DataGrid(theme),
});
